import { useEffect, useRef } from 'react';
import api from '../services/api';

/**
 * On first load inside Shopify Admin, exchanges the App Bridge session token
 * for an offline access token (if one doesn't already exist).
 *
 * This ensures the backend has a stored Shopify API token for making
 * Admin API calls (creating orders, managing products, registering webhooks).
 *
 * Runs once per app mount. Non-blocking — failures are logged but don't
 * break the UI since the app can still function with session-token auth.
 */
export function useSessionBootstrap() {
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    (async () => {
      try {
        const shopify = (window as any).shopify;
        if (!shopify?.idToken) return; // Not in embedded context

        const sessionToken = await shopify.idToken();
        if (!sessionToken) return;

        // Extract shop from the session token (JWT) to check status
        // The token's dest claim has the shop URL, but we can also
        // just call token-exchange which is idempotent
        await api.post('/auth/token-exchange', { sessionToken });
      } catch (error) {
        // Non-blocking — the app still works with session-token auth
        console.warn('Session bootstrap: token exchange failed', error);
      }
    })();
  }, []);
}
